<template src="./Profile.html">

</template>

<script>
import EditProfile from './EditProfile'
import { getUserInfo } from '@/services/auth'

export default {
  name: 'Profile',
  components: {
    EditProfile
  },
  data () {
    return {
      showEdit: false
    }
  },
  mounted () {
    this.loadInfo()
  },
  methods: {
    closeEdit () {
      this.switchComponent = ''
    },

    loadInfo () {
      getUserInfo()
        .then(res => {
          this.profileInfo = res.data
        })
        .catch(() => {
          this.$notify({
            message: 'Ooppss something went wrong'
          })
        })
    },

    updateInfo (data) {
      this.profileInfo = {
        ...this.profileInfo,
        ...data
      }
    }
  }
}
</script>

<style lang="scss" src="../../sass/profile.scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/profile/Profile.vue